"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _axios = _interopRequireDefault(require("axios"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function AddtoCart(_x) {
  return _AddtoCart.apply(this, arguments);
}

function _AddtoCart() {
  _AddtoCart = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(itemCode) {
    var quantity,
        response,
        _args = arguments;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            quantity = _args.length > 1 && _args[1] !== undefined ? _args[1] : 1;
            _context.prev = 1;
            _context.next = 4;
            return (0, _axios["default"])({
              method: 'PUT',
              url: '/api/cart/itemcode/' + itemCode + '/' + quantity
            });

          case 4:
            response = _context.sent;
            return _context.abrupt("return", response);

          case 8:
            _context.prev = 8;
            _context.t0 = _context["catch"](1);
            throw _context.t0;

          case 11:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[1, 8]]);
  }));
  return _AddtoCart.apply(this, arguments);
}

var _default = AddtoCart;
exports["default"] = _default;